<template>
  <v-container fluid grid-list-md class=" layout px-0 pt-0 ">
    <v-layout row wrap>      
      <div class="fs-map-container " >
        <l-map
          ref="map"
          :zoom="zoom"
          :maxZoom="20"
          :center="mapCenter"
          :bounds="bounds"
          style="min-height:300px;"
          @update:zoom="zoomUpdate" 
        >
          <!-- <l-marker v-if="marker" :lat-lng="marker" :icon="locationIcon"></l-marker> -->
          <l-tilelayer :url="url" :attribution="attribution"  :options="{ maxZoom: 20 }"></l-tilelayer>          
          <l-group >
            <dd-marker-cluster ref="mapCluster" v-if="clustering">
            <l-marker
              v-for="asset of selectedAssets"
              :lat-lng="toLatLng(asset.lat,asset.lon)"
              :icon="assetIcon(asset)"
              @click="showAssetDetails(asset)"
              :key="asset.id"
            ></l-marker>
            </dd-marker-cluster>
            <l-group v-else>
              <l-marker
              v-for="asset of selectedAssets"
              :lat-lng="toLatLng(asset.lat,asset.lon)"
              :icon="assetIcon(asset)"
              @click="showAssetDetails(asset)"
              :key="asset.id"
            ></l-marker>
            </l-group>
          </l-group>    
          <l-group v-if="showTraffic">
            <l-group 
                v-for="line of trafficLinears" 
                :key="line.identifier">
                <l-polyline                   
                  :lat-lngs="decodePolyLine(line.location.geometry)"
                  color="red"
                  :weight="8"
                  :opacity="0.6"
                  :fill="false"
                  @mouseover="hoveredPolyLine=line"
                  @mouseleave="hoveredPolyLine=line"            
                >
                  <l-tooltip>                                
                    <div style="width:340px;">
                        <traffic-details :traffic="line"></traffic-details>                             
                    </div>                                
                  </l-tooltip>                        
                </l-polyline>
                <l-marker              
                  :lat-lng="toLatLng(line.location.from.lat, line.location.from.lon)"
                  :icon="trafficIcon(line)"                
                  :key="line.id"                                                    
                >
                <l-tooltip>                                
                    <div style="width:340px;">
                        <traffic-details :traffic="line"></traffic-details>                             
                    </div>                                
                  </l-tooltip>                        
              </l-marker>
              
            </l-group>
            <l-group 
                v-for="point of trafficPoints" 
                :key="point.identifier">
                  <l-marker              
                    v-if="point.location.point"
                    :lat-lng="toLatLng(point.location.point.lat, point.location.point.lon)"
                    :icon="trafficIcon(point)"                
                    :key="point.id"
                    @mouseover="hoveredPolyLine=point"
                    @mouseleave="hoveredPolyLine=point" 
                  >
                  <l-tooltip>                                
                    <div >
                        <traffic-details :traffic="point"></traffic-details>                             
                    </div>                                
                  </l-tooltip>    
                </l-marker>
            </l-group>
          </l-group>

          <l-control-zoom position="topleft"></l-control-zoom>
        </l-map>        
      </div>

      <div class="map-settings-button" style="margin-left:260px;">        
        <!-- <dd-tooltip text="Sluit overzicht"> -->
          <v-btn fab  color="accent" v-if="showAssetList" @click="showAssetList = false">
            <v-icon >close</v-icon>
          </v-btn>
        <!-- </dd-tooltip> -->
        <!-- <v-btn fab  color="accent" v-if="!showAssetList" @click="showAssetList = true">
          <v-icon >list</v-icon>
        </v-btn>         -->
        <!-- <dd-tooltip text="Open filter configuratie"> -->
          <v-btn fab  color="accent"  @click="showMapConfiguration = true" class="btn-map-config">
            <v-icon >settings</v-icon>
          </v-btn>
        <!-- </dd-tooltip> -->
      </div>
      <div class="quick-map-config">        
        <div class="quick-map-top-buttons">
          <!-- <dd-tooltip text="Toon lijst"> -->
            <v-btn fab dark class="mini-button" color="secondary" @click="showAssetList = !showAssetList">
              <v-icon dark size="18">list</v-icon>
            </v-btn>
          <!-- </dd-tooltip> -->
          <!-- <dd-tooltip text="Wissel kaart / satelliet"> -->
            <v-btn fab dark class="mini-button" color="secondary" @click="toggleMapType()">
              <v-icon dark size="18">layers</v-icon>
            </v-btn>
          <!-- </dd-tooltip> -->
          <!-- <dd-tooltip text="Weergave filters">             -->
            <v-btn fab dark class="mini-button" color="accent" @click="quickMapPanel = 'general'">
              <v-icon dark size="18">settings</v-icon>
            </v-btn>
          <!-- </dd-tooltip> -->
          <!-- <dd-tooltip text="Snelle kaartweergave">           -->
            <v-btn fab dark class="mini-button" color="accent" @click="quickMapPanel = 'map'">
              <v-icon dark size="18">gps_fixed</v-icon>
            </v-btn>
          <!-- </dd-tooltip> -->
        </div>
        <v-layout column pl-4 v-if="quickMapPanel == 'general'">
            <div class="quick-map-form">
            <v-checkbox
              v-model="showIdentifier"              
              label="Toon identifiers"
              dark
              dense
            ></v-checkbox>
                                 
            <v-checkbox
              v-model="showPrimaryData"              
              label="Toon primaire data"
              dark
              dense
            ></v-checkbox>
            <v-checkbox
              v-if="currentTraffic"
              v-model="showTraffic"              
              label="Toon verkeersinformatie"
              dark
              dense
            ></v-checkbox>
            <v-checkbox              
              v-model="clustering"              
              label="Gebruik clustering"
              dark
              dense
            ></v-checkbox>
            </div>         
        </v-layout>
        <v-layout column pl-4 v-if="quickMapPanel == 'map'">
          <div class="quick-map-form  white--text" >
            <div v-if="mapviewGeoZones">
              <div style="border-bottom: 1px solid #fff;margin-bottom:8px">
                <i>Snelle kaartweergave</i>
              </div>
              <v-flex xs10 style="float:left;">
                   <div v-for="view of mapviewGeoZones" :key="view.id" class="quick-map-row" @click="centerGeozone(view)">{{view.name}}</div>
              </v-flex>
              <v-flex xs2 style="float:left;">
                 <v-btn fab dark  color="accent" slot="button-top-right" @click="showAddNewQuickMapOverviewDialog=true">
                  <v-icon dark>add</v-icon>
                </v-btn> 
              </v-flex>
              
            </div>
          </div>
        </v-layout>
      </div>
      <asset-map-settings v-if="showMapConfiguration" @closeClicked="showMapConfiguration = false"></asset-map-settings>
      <transition name="slideInRight"
          enter-active-class="slideInRight"
          leave-active-class="slideOutRight"
          mode="out-in">
        <map-asset-details class="map-asset-details animated"
            v-if="selectedAsset && selectedAsset.id"
            :asset="selectedAsset"
            @closedClicked="unsetSelectedAsset()"
            @focusCurrentClicked="centerOnCurrent()"
            @cancelActionClicked="showActionCancel"
            @executeActionClicked="showActionExecute"    
            @infoActionClicked="showActionInfo"          
            @infoEventClicked="showEventInfo"
            @createManualEventClicked="createManualEvent()"
            @assetConfigurationClicked="openAssetConfiguration"
            @assetPoiWizardClicked="openPoiWizard"
          >
        </map-asset-details>        
      </transition>
      <transition name="slideInLeft"
          enter-active-class="slideInLeft"
          leave-active-class="slideOutLeft"
          mode="out-in">
        <map-asset-list class="map-asset-list animated"
            v-if="showAssetList"
            :assets="selectedAssets"
            @assetSelected="assetSelectedFromList"
          >

        </map-asset-list>        
      </transition>
      <info-asset-action 
          :asset="selectedAsset" 
          :action="selectedAction" 
          :mode="infoAssetActionMode"
          v-if="showInfoAction"  
          @closeClicked="showInfoAction = false"      
          @actionExecuted="showInfoAction = false; reloadAsset()"    
          @actionCancelled="showInfoAction = false; reloadAsset()"    
      ></info-asset-action>
      <info-asset-event
          :asset="selectedAsset" 
          :dossierItem="selectedDossierItem" 
          v-if="showInfoEvent"  
          @closeClicked="showInfoEvent = false"     
          @EventDiscarded="reloadAsset()"     
      ></info-asset-event>
      <create-manual-event
          :asset="selectedAsset"
          v-if="showCreateManualEvent"
          @closeClicked="closeCreateManualEvent"  
          @saved="manualEventSaved"        
      >
      </create-manual-event>
      <div class="selection-applied amber" v-if="assetSelectionFilter && assetSelectionFilter.rules.length > 0" @click="showMapConfiguration = true">
        <strong>Let op: </strong> er is momenteel een filter toegepast op deze weergave. Klik om filters te wijzigen of verwijderen
      </div>
    </v-layout>

    <!-- ASSET CONFIGURATION POPUP ----------------------------------->
    <v-dialog  persistent v-if="showAssetConfiguration"  v-model="dialog">     
      <v-card>
        <v-card-title :class="`modal-title-bar`" >
            <h4>Asset {{selectedAsset.name}} configureren</h4>
            <v-spacer></v-spacer>
            <i class="fas fa-times fa-2x" style="cursor:pointer;" @click="showAssetConfiguration=false"></i>                                
        </v-card-title>       
        <v-card-text>              
            <edit-asset :asset="selectedAsset" :allowNewGeoZoneEvent="allowNewGeoZoneEvent"></edit-asset>
        </v-card-text>        
      </v-card>
    </v-dialog>
    <!-- POI WIZARD POPUP ----------------------------------->
    <v-dialog  persistent v-if="selectedPoiAsset" v-model="dialog">     
      <v-card>
        <v-card-title :class="`modal-title-bar`" >
            <h4>Point of interest op asset {{selectedAsset.name}} configureren</h4>
            <v-spacer></v-spacer>
            <i class="fas fa-times fa-2x" style="cursor:pointer;" @click="selectedPoiAsset=null"></i>                                
        </v-card-title>                        
      </v-card>       
      <poi-wizard :asset="selectedPoiAsset" @close="selectedPoiAsset=null"></poi-wizard>
    </v-dialog>

    <v-dialog persistent v-model="showAddNewQuickMapOverviewDialog" width="1000" >       
        <v-card > 
            <v-card-title class="grey lighten-3">                    
                <h4>Nieuwe snelle kaart toevoegen</h4>                    
            </v-card-title>
            <v-card-text >
                    <v-flex px-3 pt-3>
                      <h3>Geef hieronder een naam op om het door u gekozen gebied op te slaan</h3>
                      <v-text-field
                          label="Naam"
                          v-model="addNewQuickMapOptions.name"             
                      ></v-text-field>
                      <v-text-field
                          label="Beschrijving"   
                          v-model="addNewQuickMapOptions.description"       
                      ></v-text-field>
                    </v-flex>
                    <v-flex  class="px-2 right-button-container">
                      <v-btn  @click="showAddNewQuickMapOverviewDialog=false">annuleren</v-btn>
                      <v-btn color="success" @click="saveViewAsQuickMapView()" :disabled="addNewQuickMapOptions.name.length < 1">opslaan</v-btn>
                    </v-flex>
            </v-card-text>
        </v-card>
    </v-dialog>

  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import * as types from "../../store/types"
import { MAP_URL, colors } from '../../config'
import Vue2Leaflet from 'vue2-leaflet'
import "leaflet/dist/leaflet.css";
import polyLineUtil from "@mapbox/polyline";

import MapMixin from '../../plugins/mixins/MapMixin.js'
import ColorMixin from '../../plugins/mixins/ColorMixin.js'
import DdTooltip from '../../components/global/DdTooltip'
import DdMarkerCluster from '../../components/map/DdMarkerCluster'
import MapAssetDetails from '../../components/asset/MapAssetDetails'
import MapAssetList from '../../components/asset/MapAssetList'
import InfoAssetAction from '../../components/asset/InfoAssetAction'
import InfoAssetEvent from '../../components/asset/InfoAssetEvent'
import AssetMapSettings from '../../components/map/AssetMapSettings'
import TrafficDetails from '../../components/traffic/TrafficDetails'
import CreateManualEvent from '../../components/asset/CreateManualEvent'
import EditAsset from '../../components/asset/EditAsset'
import PoiWizard from '../../components/geozone/PoiWizard'

export default{
  components: {
    PoiWizard,
    DdTooltip,
    MapAssetDetails,
    InfoAssetAction,
    InfoAssetEvent,
    MapAssetList,
    TrafficDetails,
    CreateManualEvent,
    EditAsset,
    AssetMapSettings,  
    'l-map': Vue2Leaflet.LMap,
    'l-tilelayer': Vue2Leaflet.LTileLayer,
    'l-marker': Vue2Leaflet.LMarker,
    'l-group': Vue2Leaflet.LLayerGroup,
    'l-popup': Vue2Leaflet.LPopup,
    'l-polyline': Vue2Leaflet.LPolyline,
    'l-tooltip': Vue2Leaflet.LTooltip,
    'l-control-zoom': Vue2Leaflet.LControlZoom,
    DdMarkerCluster
  },
  mixins: [MapMixin, ColorMixin],
  props: ['hideBreadcrumb'],
  data(){
    return {      
      url: MAP_URL,//'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      // markers:[{id:10001, position:{lat: 52, lon: 6.1}},{id:20001, position: { lat: 52.2, lon: 6.2} }],
      dialog:true,
      vm:this,
      //bounds: null,
      allowNewGeoZoneEvent:0,
      selectedPoiAsset:null,
      mapOptions: {zoomControl: false},
      showInfoAction: false,      
      showInfoEvent: false,
      selectedAction: null,
      selectedDossierItem: null,
      clustering: true,
      infoAssetActionMode: "execute",
      showAssetList: true,
      showMapConfiguration: false,
      showIdentifier: false,
      showPrimaryData: true,
      showTraffic: true,
      quickMapPanel: 'general',
      showCreateManualEvent:false,
      showAssetConfiguration:false,      
      showAddNewQuickMapOverviewDialog: false,
      
      addNewQuickMapOptions : {name: '', description:  ''}
    }
  },  
  computed:{
    ...mapGetters({        
        currentTraffic:types.CURRENT_TRAFFIC_DATA,
        assets: types.MAP_ASSETS,
        selectedAsset: types.ASSET,
        selectedAssetLastUpdate:types.ASSET_LAST_UPDATE,
        searchTerm: types.GLOBAL_SEARCH_TERM,
        assetSelectionFilter: types.ASSET_SELECTION_FILTER,
        mapviewGeoZones: types.GEO_ZONES,
        mapAssetGroupsHidden:types.MAP_ASSET_GROUPS_HIDDEN
    }),
    trafficLinears(){       
       if(!this.currentTraffic)
          return []
       return this.currentTraffic.filter( (el) =>  { 
          return (el.location && el.location.type == "linear")
       })
    },
    trafficPoints(){       
       if(!this.currentTraffic)
          return []      
       return this.currentTraffic.filter( (el) =>  { 
          return (el.location && el.location.type == "point")
       })
    },    
    filteredAssets(){
      let assets = this.assets 

      assets = assets.filter((asset) => {
          ///console.log(this.mapAssetGroupsHidden)
          let i = this.mapAssetGroupsHidden.find((ele) => ele == asset.group.name)      
              
          return (!i)
        })
      

      if(this.assetSelectionFilter){        
        for(let rule of this.assetSelectionFilter.rules){

            assets = assets.filter((a) => {
           
            if (a.group.id == rule.groupId){
  
              // obtain field                     
              if(a.customFields && a.customFields.length > 0){
                let field = a.customFields.find(e => (e.isDataField == true && e.customFieldId && e.customFieldId == rule.customFieldId))
              
                if(field){                
                  if(rule.mode == ">"){
                    if( parseFloat(field.value).toFixed(field.decimals) > parseFloat(rule.value) ){
                      return true
                    }
                  }
                  if(rule.mode == "<"){
                    if( parseFloat(field.value).toFixed(field.decimals) < parseFloat(rule.value) ){
                      return true
                    }
                  }
                  if(rule.mode == "="){
                    if( parseFloat(field.value).toFixed(field.decimals) == parseFloat(rule.value) ){
                      return true
                    }
                  }                  
                }              
              }
            }
            // another fitered group should ignore this rule.
            else{
              if(this.assetSelectionFilter.rules.filter(e => e.groupId == a.group.id ).length > 0){
                return true
              }
            }
            return false            
          })                   
        }
        
        // unfiltered ye or na
        if(this.assetSelectionFilter.showUnfiltered){          
          let addAssets = this.assets.filter((a) => {
            let exists = assets.find(x => x.id == a.id)
            if(!exists){
              let f = this.assetSelectionFilter.rules.filter(r => r.groupId == a.group.id)
              
              if(!f || f.length == 0){
                return true
              }
              return false
            }
          })          
          assets = [...assets, ...addAssets]
        }
        return assets      
      }
    
      return assets
    },
    selectedAssets(){
      let vm = this      
      
      let filteredAssets =  this.filteredAssets.filter((ele) => {
        let ret = false
        if(ele.lat && ele.lon != null){
          ret = true
        }

        if(vm.searchTerm != ''){
          ret = false          
          if(            
            (ele.lat && ele.lon) != null &&
            (ele.name.toLowerCase().includes(vm.searchTerm.toLowerCase()) ||
             ele.street.toLowerCase().includes(vm.searchTerm.toLowerCase()) ||
             ele.city.toLowerCase().includes(vm.searchTerm.toLowerCase()) ||
             ele.group.name.toLowerCase().includes(vm.searchTerm.toLowerCase()) ||
             ele.name.toLowerCase().includes(vm.searchTerm.toLowerCase()) ||
             ele.unitIdentifier.toLowerCase().includes(vm.searchTerm.toLowerCase()) ||
             JSON.stringify(ele.customFields).toLowerCase().includes(vm.searchTerm.toLowerCase())  
            ) 
            
          ){
            ret = true
          }
        }              
        return ret        
      })
      filteredAssets = filteredAssets.sort((a, b) => {
        if(a.name < b.name){
          return -1
        }
        return 1
        })      
      return filteredAssets
    },    
    trafficjamIcon(){
      return require('@/assets/images/trafficjam-white.png');
    },
  },
  watch: {
    selectedAssetLastUpdate: {
      handler(){  
        if(this.selectedAsset){
          this.reloadAsset(this.selectedAsset.id)
        }
      }
    }
  },  
  methods:{
    saveViewAsQuickMapView(){
        let zone = this.$refs.map.mapObject.getBounds(); 
        let northEast = [zone._northEast.lat, zone._southWest.lng];
        let southWest = [zone._southWest.lat, zone._northEast.lng];
      
        let coordinates = [
            [zone._northEast.lat, zone._northEast.lng],
            [zone._southWest.lat, zone._southWest.lng],
            northEast,
            southWest,
        ]
        let polygon = L.polygon(coordinates);
        let geojson = polygon.toGeoJSON();

        this.$store.dispatch(types.SAVE_GEO_ZONE, {data: { name: this.addNewQuickMapOptions.name, description: this.addNewQuickMapOptions.description, shapeType:"polygon", geoZoneTypeId:"eJBPDGVXv" ,geojson:geojson, shapeData: geojson}}).then((res) => {
                    this.$notify('Snelle kaartweergave is opgeslagen',{type: 'success', 'icon': 'checked'})
                    // Disable the popup
                    this.showAddNewQuickMapOverviewDialog =  false;
                    // Reload the 'snelle weergave' list
                    this.$store.dispatch(types.GEO_ZONES, {});
         })
        

    },
    toLatLng(lat, lon){
      return L.latLng(lat, lon)
    },
    decodePolyLine(poly){
      return polyLineUtil.decode(poly, 6);
    },
    unsetSelectedAsset(){      
      this.$store.dispatch(types.ASSET, null)
    },
    assetSelectedFromList(asset){

      this.$refs.map.mapObject.setView(L.latLng(asset.lat, asset.lon), 15);      
      this.showAssetDetails(asset)
    },
    toggleMapType(){
      if(this.mapType == 'default'){
        this.useSatMap()        
      }
      else{
        this.useDefaultMap()
      }
    },
    zoomUpdate(nv){    
      if(nv < 8){
        this.showTraffic = false
      }
      
      if(nv > 11){
        this.showIdentifier = true
      }
      else{
        this.showIdentifier = false
      }
    
    },
    trafficPointIcon(trafficObj){
      
       
    },      
    
    trafficIcon(traffic){            
      let size = 28;
      let icon = '<i class="fas fa-info" />'
      if(traffic.data.queue){        
        icon = `<img src="${this.trafficjamIcon}" style="height:${(size - 14)}px;" />`
      }

      if(traffic.location.type == 'point'){
        icon = '<i class="fas fa-bell" />'
      }

      let html = `<div style="height: ${size}px; width: ${size}px;" class="dd-traffic-marker">${icon}</div>`
      return L.divIcon({
          iconSize: new L.Point(size, size),
          iconAnchor:[(size / 2 ), ( size / 2)],
          //data: {id: asset.id, group: asset.group.name, status: asset.statusCode},
          html
        });
    },
    assetIcon(asset){      
      // color mixin method
      let color = this.assetStatusColor(asset)
      let showIdentifier = this.showIdentifier
      
      // if (asset.id % 7 == 0)
      //     color = "#F44336"
      // else if (asset.id % 13 == 0)
      //     color = "#2196F3"
      // else
      //     color = "#8BC34A"
      let isSelected = (this.selectedAsset && this.selectedAsset.id && this.selectedAsset.id == asset.id);
      let size = (asset.group.markerSize) ? asset.group.markerSize : 26;      
      let icon = (asset.group.icon) ? asset.group.icon : null;
      let shape = (asset.group.shape) ?  (asset.group.shape) : 'square'

      let html = this.generateIcon(asset, {selected: isSelected, color: color, icon: icon, size: size, shape:shape, showIdentifier: this.showIdentifier, showPrimaryData: this.showPrimaryData})


      //let shapeStyle = (asset.group.shape) ? this.generateShapeStyle(asset.group.shape, asset.group.size) : `shape-square`;
  
      
      // let iconHtml = '';
      

      // let selectedAssetClass = ""
      
      // if(this.selectedAsset && this.selectedAsset.id && this.selectedAsset.id == asset.id){
      //   selectedAssetClass = "selected-asset-marker animated infinite heartBeat "
        
      // }

      // if(icon && size > 18){
      //   if(size < 30){
      //     iconHtml = `<i class="${icon}" style="font-size: ${size - 12}px;"></i>`  
      //   }
      //   else{
      //     iconHtml = `<i class="${icon}" style="font-size: ${size - 20}px;"></i>`
      //   }        
      // }
            
      // let html = `<div class="simple-marker-pin ${selectedAssetClass}" style="background-color: ${color}; width: ${size}px;  height: ${size}px; ${shapeStyle};">${iconHtml}</div>`
                      
                
      return L.divIcon({
          iconSize: new L.Point(size, size),
          iconAnchor:[(size / 2 ), ( size / 2)],
          data: {id: asset.id, group: asset.group.name, status: asset.statusCode, color: asset.statusColor},
          html
        });
    },
    showAssetDetails(asset){
      this.unsetSelectedAsset()
      this.reloadAsset(asset.id) 
    },
    centerOnCurrent(){
      this.$refs.map.mapObject.setView(L.latLng(this.selectedAsset.lat, this.selectedAsset.lon), 17);      
    },
    startUpdateService(){
      this.$store.dispatch(types.ASSET_MAP_UPDATER_START, {data: { run: true }, params:{interval:10000}})
    },
    showActionExecute(action){
      this.infoAssetActionMode = "execute"
      this.selectedAction = action
      this.showInfoAction = true
      
    },
    showActionCancel(action){
      this.infoAssetActionMode = "cancel"
      this.selectedAction = action
      this.showInfoAction = true
    },
    showActionInfo(action){
      
      this.infoAssetActionMode = "info"
      this.selectedAction = action
      this.showInfoAction = true
    },
    showEventInfo(e){      
      this.selectedDossierItem = e
      this.showInfoEvent = true      
    },
    createManualEvent(){
      this.showCreateManualEvent=true
    },
    closeCreateManualEvent(){
      this.showCreateManualEvent=false 
    },
    openAssetConfiguration(asset){
        this.showAssetConfiguration=true
    },
    openPoiWizard(){      
      this.selectedPoiAsset=this.selectedAsset
    },
    manualEventSaved(saved){
      this.$notify("Event opgeslagen", {duration:10000, type: 'success', icon:'check'} );      
      this.reloadAsset()
      this.closeCreateManualEvent()
    },
    reloadAsset(selectedAssetId = null) {
      let p = new Promise((resolve, reject) => {      
        let vm = this
        this.$nextTick(() => {
          let assetId = (selectedAssetId) ? selectedAssetId : vm.selectedAsset.id
          vm.showInfoEvent = false
          
          vm.$store.dispatch(types.ASSET, {data: {id: assetId},params : { include: 'group,type,timeSeries,geoZoneEvents,mainImage'}}).then((asset) => {          
            vm.$store.dispatch(types.ASSET_PROCESSED_EVENTS, {data: {id: assetId}, params: {per_page: 10, include: 'itemType,event.eventType, event.eventSeverity'}})
              vm.center = [this.selectedAsset.lat, this.selectedAsset.lon]
              vm.$nextTick(() => {
                vm.$store.dispatch(types.ASSET_MAP_UPDATER, vm.selectedAsset);
                resolve()
              })            
            })                    
          })
        })
        return p
      },
      mapfix(){
          this.$nextTick(() => {
              window.dispatchEvent(new Event('resize'));
          })                
      },
      loadCurrentTraffic(){
          let vm = this
          this.$store.dispatch(types.CURRENT_TRAFFIC_DATA).then( (success) => {
              // if CURRENT TRAFFIC DATA IS ACTIVE, KEEP RELOADING IT EVERY MINUTE
              if(success){
                 setTimeout( ()=>{ vm.loadCurrentTraffic()},60000)            
              }
          });
      }
  },
  created(){
    this.$nextTick(() => {

    })
    
  },
  mounted(){
    
    if(this.hideBreadcrumb){

      this.$store.dispatch(types.HIDE_BREADCRUMBS, true);
      this.$store.dispatch(types.GEO_ZONES, {});
      this.$store.dispatch(types.TOPBAR_DENSE, true);
      this.$store.dispatch(types.MAIN_MENU_SHOWN, {show:false} )      
    }
    //this.$store.dispatch(types.FS_LOADING, true)
      this.$store.dispatch(types.MAP_ASSETS, {data: {query: null}, params: { include:'group,timeSeries', 'disablePaging' : true } }).then(() => {        
        this.$store.dispatch(types.FS_LOADING, false)
        let count = (this.assets.filter((ele) => ele.lat  == null)).length
        
        if(count > 0){          
          this.$notify(`Voor ${count} assets zijn geen locatiegegevens beschikbaar. Controleer de configuratie.`, {color: 'orange', timeout: 7000})
        }
        
           
        if(this.$route.query.assetId){
          let vm = this
          this.reloadAsset(this.$route.query.assetId).then(() => {
            
            vm.mapCenter = [this.selectedAsset.lat, this.selectedAsset.lon]
            vm.zoom = 16
          })
          
        }
        else{
          let coordinates = this.filteredAssets.map((ele) => {
            if(ele.lat && ele.lon) {
              return [ele.lat, ele.lon]
            }
          }).filter(ele => ele)
        
          this.bounds = coordinates
        }
      
        this.loadCurrentTraffic();

      })
    this.startUpdateService()
    
      // var wsServer = 'ws://192.168.178.97:9001';
      // var websocket = new WebSocket(wsServer);
      // websocket.onopen = function (evt) {
      //   console.log("Connected to WebSocket server.");
      // };

      // websocket.onclose = function (evt) {
      //   console.log("Disconnected");
      // };

      // websocket.onmessage = function (evt) {
      //   console.log('Retrieved data from server: ' + evt.data);
      // };

      // websocket.onerror = function (evt, e) {
      //   console.log('Error occured: ' + evt.data);
      //};
  },
  beforeDestroy(){
    this.$store.dispatch(types.HIDE_BREADCRUMBS, false);
    this.$store.dispatch(types.MAIN_MENU_SHOWN, {show:true} )
    this.$store.dispatch(types.TOPBAR_DENSE, false);
    
    this.$store.dispatch(types.GLOBAL_SEARCH_TERM, '')
    this.$store.dispatch(types.ASSET_MAP_UPDATER_STOP)
  }
}
</script>
<style>
  .fs-map-container{
    height: calc(100vh - 60px);
    overflow-y:hidden;

    z-index: 1;
    width: 100%;
    margin-bottom: -160px;
  }

  

  .selected-asset-marker{
    /* width: 30px !important;
    height: 30px !important; */
    box-shadow: -6px 6px 6px -1px rgba(0,0,0,0.7) !important;
    z-index: 1000 !important;
  }

  .map-asset-list{

    position: absolute;
    left:0;
    z-index: 10;
    overflow-y: hidden;
    width: 100%;
    border-right: 1px solid rgba(0,0,0,0.12);

  }


  .map-asset-details{

    position: absolute;
    right:0;
    z-index: 10;
    overflow-y: hidden;
    width: 20%;
    border-left: 1px solid rgba(0,0,0,0.12);

  }

  .map-settings-button{
    position: fixed;
    margin-bottom: 50px;
    margin-left: 10px;
    left:0;
    bottom:0;
    z-index: 1000;
  }

  .btn-map-config{

  }

.selection-applied{
  padding: 16px 16px;
  font-size: 15px;
  position: fixed;
  width: calc(100% + 4px);
  z-index: 1000;
  bottom: 0;

  
  
}

.quick-map-config{
  bottom: 0;
  right:0;
  width: 300px;
  background-color: rgba(0,0,0,0.82);
  z-index: 1;
  position: fixed;
  padding-bottom: 20px;
  border-top-left-radius: 10px;  
  padding-top: 16px;
}

.quick-map-form{
  display: flex;
  flex-direction: column;
  margin-top: 0px !important;
  padding: 0px;
}

.quick-map-form .v-input{
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  height: 24px !important;
}

.quick-map-top-buttons{
  position: absolute;
  margin-top: -32px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.mini-button{
  width: 28px !important;
  height: 28px !important;
}

.quick-map-row{
  padding-top: 2px; 
  padding-bottom:2px; 
  cursor:pointer;
}

.quick-map-row:hover{
  background-color: #777;
}

</style>
